import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

let authInstance = null;
let dbInstance = null;

export const initFirebase = async () => {
  if (authInstance) return { auth: authInstance, db: dbInstance };
  
  try {
    const API_URL = process.env.REACT_APP_API_URL || '/api';
    const res = await fetch(`${API_URL}/auth/config`);
    const firebaseConfig = await res.json();
    
    if (!firebaseConfig || !firebaseConfig.apiKey) {
      throw new Error("Invalid Firebase configuration received from backend");
    }
    
    const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
    authInstance = getAuth(app);
    dbInstance = getFirestore(app);
    
    return { auth: authInstance, db: dbInstance };
  } catch (error) {
    console.error("CRITICAL: Failed to load Firebase config:", error);
    // Return a dummy object to prevent destructuring crashes in AuthContext
    return { auth: null, db: null };
  }
};

export let auth = null;
export let db = null;

initFirebase().then((instances) => {
  auth = instances.auth;
  db = instances.db;
}).catch(err => {
  console.error("Top-level Firebase init failed:", err);
});
